import React from 'react'
import { useTranslation } from 'translations'
import { Section } from '../components/section'
import { PermissionToggle } from '../components/permissionToggle'
import { Permission } from 'settings/schema'

interface CartPermissionsSectionProps {
    isAdminGranted: boolean
    handlePermissionClick: (permission: Permission, granted: boolean) => void
}

export const CartPermissionsSection = ({ isAdminGranted, handlePermissionClick }: CartPermissionsSectionProps) => {
    const { t } = useTranslation()

    return (
        <Section title={t('settings.users.form.sections.cart')} className="cart-permissions">
            <div className="row">
                <PermissionToggle
                    permission="read_carts"
                    handleClick={handlePermissionClick}
                    disabled={isAdminGranted}
                />
                <PermissionToggle
                    permission="write_carts"
                    handleClick={handlePermissionClick}
                    disabled={isAdminGranted}
                />
            </div>
        </Section>
    )
}
